import React from "react";
import { VStack } from "@astryxdesign/core";
import styles from "./NavRail.module.css";

export interface NavRailProps {
  /** Expanded panel content, e.g. a list of `NavRailItem`s. */
  children: React.ReactNode;
}

/**
 * Docked rail. An in-flow column that pushes and shrinks the main content
 * beside it (no overlay) — just the list, no header. Purely presentational —
 * no app logic (dnd, navigation, delete) lives here; the caller supplies
 * fully-wired `NavRailItem`s as `children`.
 */
const NavRail = ({ children }: NavRailProps): React.ReactElement => {
  return (
    <nav className={styles.expanded} aria-label="Script sections and questions">
      <VStack gap={3} className={styles.list}>
        {children}
      </VStack>
    </nav>
  );
};

export default NavRail;
